// import "../styles/main.css";
import "./src/styles/main.scss";
import "./src/images/favicon.ico";
import { getParam, validateParams, formatParams, sanitizeHTML } from "./src/scripts/params";

function listenToParent() {
  window.addEventListener("message", event => {
    // IMPORTANT: check the origin of the data!
    if (event.origin === "http://localhost:9000") {
      // The data was sent from your site.
      // Data sent with postMessage is stored in event.data:
      console.log("postMessage | parent to child", event);
    }
    // else {
    //   // The data was NOT sent from your site!
    //   // Be careful! Do not use it. This else branch is
    //   // here just for clarity, you usually shouldn't need it.
    //   // return;
    // }
  });
}

function log(x) {
  console.log(x);
}

function logError(errorName, x) {
  console.groupCollapsed(errorName);
  console.error(x);
  console.groupEnd(errorName);
}

function logGroup(groupName, x) {
  console.groupCollapsed(groupName);
  log(x);
  console.groupEnd();
}

function openNav() {
  document.getElementById("myNav").style.display = "block";
}

function closeNav() {
  document.getElementById("myNav").style.display = "none";
}

const trace = label => value => {
  console.groupCollapsed(`trace | ${label}`);
  console.log(value);
  console.groupEnd(`trace | ${label}`);
  return value;
};

const pipe = (...fns) => x => fns.reduce((y, f) => f(y), x);

async function postToCallbackURL({ params, payload, attempt }) {
  const rawResponse = await fetch(params.data.callbackUrl, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      gatewayInput: params,
      gatewayOutput: { ...payload, attempt: attempt.getCount() },
    }),
  });

  const res = await rawResponse.json();

  return res;
}

function wait(ms) {
  return new Promise(resolve => setTimeout(() => resolve(ms), ms));
}

async function initialiseBraintree({
  submitButton,
  paymentCard,
  dropInSelector,
  token,
  params,
  resultsDiv,
}) {
  const attempt = new AttemptCounter();
  // paymentCard.style.display = "block";
  paymentCard.style.visibility = "visible";

  let dropInInstance;

  try {
    dropInInstance = await braintree.dropin.create({
      authorization: token,
      container: dropInSelector,
      card: {
        cardholderName: {
          required: true,
        },
      },
      applePay: {
        displayName: "Monash University",
        paymentRequest: {
          total: {
            label: "Monash University",
            amount: params.data.amount,
          },
        },
        requiredBillingContactFields: ["postalAddress"],
      },
      googlePay: {
        // merchantId: params.data.googleMerchantId,
        merchantId: "BCR2DN6TTOH7XR3Y",
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: params.data.amount,
          currencyCode: "AUD",
        },
        cardRequirements: {
          billingAddressRequired: true,
        },
      },
    });
  } catch (err) {
    return logError("braintree.dropin.create | error", err);
  }

  submitButton.addEventListener("click", async function() {
    resultsDiv.classList.remove("--results__error");
    submitButton.disabled = true;

    const msgObj = {
      type: "payment complete",
      data: {},
    };

    try {
      const payload = await fetchNonce(dropInInstance);
      console.log("NONCE PAYLOAD: ", payload);
      // const payload = {};

      submitButton.style.display = "none";

      resultsDiv.innerHTML = "Making payment..";
      resultsDiv.classList.add("--results__loading");

      animateToPoint(document.querySelector("#point-payment"));

      // await wait(1000);

      openNav();

      const res = await postToCallbackURL({ params, payload, attempt });

      logGroup("postToCallbackURL | response", res);

      // const msgObj = {
      //   type: "payment complete",
      //   data: res,
      // };

      msgObj.data = res;

      if (res.statusCode) {
        switch (res.statusCode) {
          case "404":
            throw res;
          case "403":
            throw res;
          case "201":
            msgObj.type = "payment complete with error";
            break;
          case "202":
            msgObj.type = "payment complete forecast letter";
            break;
          case "200":
            msgObj.type = "payment complete";
            msgObj.data = res;
        }
      }

      await wait(2000);

      dropInInstance.clearSelectedPaymentMethod();
      dropInInstance.teardown();
      submitButton.style.display = "none";

      closeNav();

      resultsDiv.innerHTML = "Success";
      resultsDiv.classList.add("--results__success");

      document.querySelector(".cancel-container").style.display = "none";

      // submitButton.style.display = "block";
      // submitButton.disabled = false;

      animateToPoint(document.querySelector("#point-success"));

      await wait(2000);

      // window.parent.postMessage("done", "*");

      // const closeMessage = `/*MPG*/${JSON.stringify(msgObj)}`;

      // window.opener.postMessage(closeMessage, "*");

      // setTimeout(() => window.close(), 2000)

      // window.open('','_self').close()
      // open(location, '_self').close();

      // return res;
    } catch (err) {
      attempt.increment();
      const errPrefix = "Error: ";

      resultsDiv.innerHTML =
        (err.customMessage && errPrefix + err.customMessage) ||
        errPrefix + "Something went wrong";
      resultsDiv.classList.add("--results__error");

      submitButton.disabled = false;
      submitButton.style.display = "block";
      // document.querySelector(".bar__fill").style.background = "#ae1100"

      closeNav();
      logError("submit payment | error", err);
      return err;
    }

    try {
      const closeMessage = `/*MPG*/${JSON.stringify(msgObj)}`;
      window.opener.postMessage(closeMessage, "*");
      return;
    } catch (err) {
      console.log(err);
      alert("Payment complete - you can now close this window.");
    }
  });

  dropInInstance.on("paymentMethodRequestable", function(event) {
    // log(event.type); // The type of Payment Method, e.g 'CreditCard', 'PayPalAccount'.
    // log(event.paymentMethodIsSelected); // True if a customer has selected a payment method when paymentMethodRequestable fires.
    logGroup("paymentMethodRequestable | event", event);

    // if (event.type === "CreditCard") {
    submitButton.removeAttribute("disabled");
    submitButton.style.display = "block";
    // }
  });

  dropInInstance.on("noPaymentMethodRequestable", function(event) {
    logGroup("noPaymentMethodRequestable | event", event);
    submitButton.setAttribute("disabled", true);
    submitButton.style.display = "none";
  });

  // submitButton.style.display = "block";
}
function fetchNonce(dropInInstance) {
  return new Promise((resolve, reject) => {
    dropInInstance.requestPaymentMethod(function(
      requestPaymentMethodErr,
      payload
    ) {
      if (requestPaymentMethodErr) {
        logError("requestPaymentMethod | error", requestPaymentMethodErr);
        return reject({
          type: "Network error",
          statusCode: 500,
          trace: "requestPaymentMethodErr | Failed to fetch nonce token",
          customMessage: "Something went wrong",
        });
      }

      logGroup("requestPaymentMethod | response", {
        requestPaymentMethodErr,
        payload,
      });

      resolve(payload);
    });
  });
}

function displayUserInformation({ email }) {
  const emailText = document.querySelector(".heading-container__text-email");
  emailText.innerHTML = `email: ${sanitizeHTML(email.toLowerCase())}`;
}

function displayItemInformation({ item, amount }) {
  const itemText = document.querySelector(".item-container__text-item");
  const amountText = document.querySelector(".item-container__text-amount");

  itemText.innerHTML = sanitizeHTML(item);
  amountText.innerHTML = `$${sanitizeHTML(amount)} AUD`;
}

function logPipe(label, pipe, input) {
  console.group(`pipe | ${label}`);
  logGroup("x: ", input);
  const x = pipe(input);
  logGroup("f(x): ", x);
  console.groupEnd(`pipe | ${label}`);
  return x;
}

function decodeB64(encodedString) {
  return atob(encodedString);
}

function getQueryString() {
  return window.location.search;
}

function ignoreConsole() {
  // Remove console statements in prod //
  function noop() {}

  if (process.env.NODE_ENV !== "development") {
    console.log = noop;
    console.warn = noop;
    console.error = noop;
    console.group = noop;
    console.groupCollapsed = noop;
    console.groupEnd = noop;
  }
}

function onCancelPayment() {
  console.log("Cancel");
  const msgObj = {
    type: "cancel",
    data: { message: "Payment cancelled by user" },
  };

  const cancelMessage = `/*MPG*/${JSON.stringify(msgObj)}`;

  if (window.confirm("Close window?")) {
    window.opener.postMessage(cancelMessage, "*");
  }
}

function registerCloseButton() {
  const el = document.getElementById("close-button");
  console.log(el);
  el.onclick = onCancelPayment;
}

function registerCloseContainer() {
  if (window.opener) {
    document.querySelector(".cancel-container").style.display = "block";
  }
}

class AttemptCounter {
  constructor() {
    this.attempt = 0;
  }

  increment() {
    this.attempt += 1;
    return this.attempt;
  }

  getCount() {
    return this.attempt;
  }
}

function mountProgressBox() {
  var $boxOne = document.querySelector(".box:nth-child(1)"),
    $boxTwo = document.querySelector(".box:nth-child(2)"),
    $boxThree = document.querySelector(".box:nth-child(3)");

  var boxOne = new TimelineMax(),
    boxTwo = new TimelineMax(),
    boxThree = new TimelineMax();

  boxOne
    .to($boxOne, 0.6, {
      opacity: 0.25,
      scale: 1,
      ease: Back.easeOut,
    })
    .to(
      $boxOne,
      0.6,
      {
        rotation: 4,
        ease: Back.easeOut,
      },
      2
    );

  boxTwo
    .to(
      $boxTwo,
      0.6,
      {
        opacity: 0.5,
        scale: 1,
        ease: Back.easeOut,
      },
      0.6
    )
    .to(
      $boxTwo,
      0.6,
      {
        rotation: -4,
        ease: Back.easeOut,
      },
      1.8
    );

  boxThree.to(
    $boxThree,
    0.6,
    {
      opacity: 1,
      scale: 1,
      ease: Back.easeOut,
    },
    1.2
  );
}

function prevAll(element) {
  var result = [];

  while ((element = element.previousElementSibling)) result.push(element);
  return result;
}

function nextAll(element) {
  var result = [];

  while ((element = element.nextElementSibling)) result.push(element);
  return result;
}

function animateToPoint(item) {
  const allPoints = [...item.parentElement.children];
  const getTotalPoints = document.querySelectorAll(".point").length;
  const getIndex = allPoints.indexOf(item);
  const getCompleteIndex = allPoints.indexOf(
    document.querySelector(".point--active")
  );

  TweenMax.to(document.querySelector(".bar__fill"), 0.6, {
    width: ((getIndex - 1) / (getTotalPoints - 1)) * 100 + "%",
  });

  if (getIndex => getCompleteIndex) {
    const currentActivePointEl = document.querySelector(".point--active");
    currentActivePointEl.classList.add("point--complete");
    currentActivePointEl.classList.remove("point--active");

    item.classList.add("point--active");
    prevAll(item).map(el => el.classList.add("point--complete"));
    nextAll(item).map(el => el.classList.remove("point--complete"));
  }
}

async function main() {
  listenToParent();
  ignoreConsole();
  registerCloseContainer();
  registerCloseButton();

  const dropInSelector = ".payment-container__dropin";
  const submitButton = document.querySelector(
    ".payment-container__submit-button"
  );
  const paymentCard = document.querySelector(".payment-container");
  const resultsDiv = document.querySelector(".payment-container__results");

  const _pipe = pipe(
    getParam,
    trace("getParam"),
    decodeB64,
    trace("decodeB64"),
    formatParams,
    trace("formatParams"),
    validateParams,
    trace("validateParams")
  );

  const params = logPipe("params", _pipe, {
    key: "data",
    queryString: getQueryString(),
  });

  if (params.valid) {
    displayUserInformation({
      email: params.data.email,
    });

    displayItemInformation({
      item: params.data.item,
      amount: params.data.amount,
    });

    mountProgressBox();

    initialiseBraintree({
      params,
      resultsDiv,
      submitButton,
      paymentCard,
      dropInSelector,
      token: params.data.token,
    });
  }
}

main();
